import {createFileRoute} from '@tanstack/react-router';

import {PublicReportPage} from '@/modules/jobs/components/public-report/PublicReportPage';

/**
 * The public signing link (DERP-247). A sibling of `/login`, NOT a child of
 * `_authenticated`: the whole point is that the person opening it has no account,
 * so there is no session to guard and nothing to redirect them to.
 *
 * The token in the path is the entire authorisation. It is never stored — only
 * its hash is — so this URL is the only copy, and the server treats a wrong,
 * revoked and expired token identically.
 */
export const Route = createFileRoute('/report/$token')({
  component: PublicReport,
});

function PublicReport() {
  const {token} = Route.useParams();
  return <PublicReportPage token={token} />;
}
